// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"315":"2b570f65","595":"cd362a01","926":"2d6d300e"}[chunkId] + ".js";
};